module.exports = __webpack_public_path__ + "static/BOTGold-80fa889bdd81b8b7ca2e98e1b761e99c.mp4";